import React,{useEffect, useState } from "react";
import { useSelector} from "react-redux";
import { useNavigate } from "react-router-dom";
import DashboardData from "./dashboardData/DashboardData";
import DashboardReport from "./dashboardReport/DashboardReport";
import { getDashboardData, dashboardGraph } from './DashboardHelper';
import DashboardBalance from "./dashboardBalance/DashboardBalance";
import DashboardTable from "./dashboardTable/DashboardTable";

function Dashboard() {
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);
  const { userType: role} = useSelector((state) => state.auth.user);
  const navigate = useNavigate();
  const [dashboardData, setDashboardData] = useState({});
  const [dashBalance, setDashBalance] = useState([]);
  const [dashStock, setDashStock] = useState([]);
  const [dashOrders, setDashOrder] = useState([]);
  const [minimumBalance, setMinimumBalance] = useState(0);
  const [dashReport, setDashReport] = useState({});

  useEffect(() => {

    const getAllDatas = async () => {
      setDashboardData({});
      setDashBalance([]);
      setDashStock([]);
      setMinimumBalance(0);
      setDashReport({});
      setLoading(true);
      Promise.all([getDashboardData(token), dashboardGraph(token)]).then((values) => {
 
        if (values && values.length > 0) {

        if (Array.isArray(values) && values.length > 0 && values[0]?.code === 200) {
            const { balance, stock, orders, minimumCreditAmount, totalMerchents, totalOrder, totalOrderAmount, } = values[0].data;

            setDashBalance(balance)
            setDashStock(stock)
            setDashOrder(orders)
            setMinimumBalance(minimumCreditAmount);
            setDashboardData({ totalMerchents, totalOrder, totalOrderAmount, balance })
          }
          if (Array.isArray(values) && values.length > 0 && values[0]?.code === 200) {
            setDashReport(values[1].data)
            
          }
        }

      }).catch((error) => {
          setDashboardData({});
          setDashBalance([]);
          setDashStock([]);
          setMinimumBalance(0);
          setDashReport({});
      console.error("Error in dashboard fetch:", error);
      // Optionally show toast or set an error state
    })
    .finally(() => {
      setLoading(false); // Always turn off loading, success or error
    });
    }
    getAllDatas()

    
  }, [token])



  if (!user || !token) {
    // You can show a loading state or redirect to login if the user isn't authenticated
    navigate("/login");
    return null; // or return a loading spinner
  }

  if (loading) {
    return <div><div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          pointerEvents: 'none', // Allow clicks through
          zIndex: 999,
        }}
      >
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div></div>; // You can use a spinner here
  }

  return (
    <div>
     
        <DashboardData {...dashboardData} />
        <DashboardBalance dashBalance={dashBalance} dashStock={dashStock} dashOrders={dashOrders} minimumBalance={minimumBalance} />
        {role !== 4 && Object.keys(dashReport).length > 0 && <DashboardReport report={dashReport} />}
       <DashboardTable />

  
    </div>
  );
};

export default Dashboard;
